(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("OptaveJavaScriptSDK", [], factory);
	else if(typeof exports === 'object')
		exports["OptaveJavaScriptSDK"] = factory();
	else
		root["OptaveJavaScriptSDK"] = factory();
})((function() { return typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : (typeof globalThis !== 'undefined' ? globalThis : this)); })(), () => {
return 